import React from "react";

import { Icon, IconProps } from "../";

export const RemoveIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <rect x="4" y="11.25" width="16" height="1.5" rx="0.75" />
    </Icon>
  );
};
